import switchBaseModal from "./switch_base_modal.js";
import siteHeader from "./site_header";
import header from "./header";
import { action, m_action } from "./add_like_action";
import { isMobile } from "@shared/scripts/utils/tool";

export const addWindowQueue = name => {
  window[`${name}Queue`] = [];
};

export const addResizeListener = (callback, immediate = true) => {
  const handleResize = isFirst => {
    const exec = () => {
      const mobile = isMobile();
      callback(mobile);
    };
    // 调用回调函数，并传入当前是否是移动端的布尔值 (不清楚为什么第一时间拿不到，需要等一下re-render)
    if (isFirst) {
      requestAnimationFrame(exec);
    } else {
      setTimeout(exec);
    }
  };

  // 监听窗口的 resize 事件
  window.addEventListener("resize", handleResize, false);

  // 立即执行一次，以确保在屏幕尺寸变化前也能获取到当前状态
  immediate && handleResize(true);

  // 返回一个函数，用于取消监听
  return () => {
    window.removeEventListener("resize", handleResize, false);
  };
};

/**
 * 响应式手机端判定
 * @returns
 */
export const reactiveIsMobile = callback => {
  addResizeListener(callback);
};

const switchFn = (options = {}) => {
  let isPcExecuted = false;
  let isMobileExecuted = false;

  const { pcCallback, mobileCallback } = {
    pcCallback: () => {
      siteHeader();
      m_action();
    },
    mobileCallback: () => {
      header();
      action();
    },
    ...options,
  };

  switchBaseModal();
  reactiveIsMobile(res => {
    const pH = document.querySelector(".pc-header");
    const mH = document.querySelector(".mobile-header");
    const mB = document.querySelector(".mobile-sidebar");
    const mL = document.querySelector(".sidebar__layer");
    const db = document.querySelector("#dailies-show .synced__bottom-wrapper");
    console.log("reactive mobile", res);
    if (res) {
      pH && (pH.style.zIndex = "-100");
      mH && (mH.style.zIndex = "100");
      mB && (mB.style.display = "flex");
      mL && (mL.style.display = "block");
      db && (db.style.display = "none");
      db && (db.style.overflow = "hidden");
      if (!isMobileExecuted) {
        mobileCallback();
        isMobileExecuted = true;
      }
    } else {
      pH.style.zIndex = "100";
      mH.style.zIndex = "-100";
      mB.style.display = "none";
      mL.style.display = "none";
      db && (db.style.display = "block");
      db && (db.style.overflow = "unset");
      if (!isPcExecuted) {
        pcCallback();
        isPcExecuted = true;
      }
    }
  });
};

export default switchFn;
